// @file buildPost function requires as few attributes and return a full Post
// with undefined attributes as default values
import { getSortIndex } from 'surface/sorter'
import type { Post, PostAttributes, PostPositionMap } from 'types'
import { addCidIfAbsent } from 'vuexstore/helpers/post'

// dependency
const DEFAULT_WIDTH = 200

const getAutoPositionForNewPost = (): PostPositionMap => {
  let headerHeight = 0
  const surfaceHeader = document.getElementById('surface-header')
  if (surfaceHeader) {
    headerHeight = surfaceHeader.getBoundingClientRect().bottom
  }
  // first new post is 16px below surface header
  let maxY = 16
  document.querySelectorAll("[data-view-mode='show']").forEach((elem) => {
    // each new post is 8px below the previous one
    // have to subtract the header height because the canvas area starts below the header
    maxY = Math.max(maxY, elem.getBoundingClientRect().bottom - headerHeight + 8)
  })
  return { left: 16, top: maxY }
}

const buildPost = (attr: PostAttributes = {}, { state, getters }): Post => {
  const timeNow = new Date()
  const wallLayout = getters.format
  let attributes = attr

  if (wallLayout === 'free' && !attributes.position) {
    attributes = Object.assign(getAutoPositionForNewPost(), attributes)
  }
  const finalAttributes: Post = {
    cid: addCidIfAbsent(attributes).cid,
    wall_id: state.wall.id,
    published: getters.canIModerate || !getters.requireApproval,
    author_id: state.user.id,
    width: DEFAULT_WIDTH,
    body: attributes.body || '',
    subject: attributes.subject || '',
    attachment: attributes.attachment || '',
    attachment_caption: attributes.attachment_caption === undefined ? null : attributes.attachment_caption,
    sort_index: attributes.sortIndex || attributes.sort_index || getSortIndex(),
    created_at: timeNow.toISOString(),
    updated_at: timeNow.toISOString(),
    wall_section_id: attributes.wallSectionId || attributes.wall_section_id,
    col_id: attributes.col_id,
    row_id: attributes.row_id,
    top: attributes.top,
    left: attributes.left,
    location_point: attributes.location_point || attributes.locationPoint,
    location_name: attributes.location_name || attributes.locationName,
    color: attributes.color,
    wish_content: attributes.wish_content,
  }

  if (getters.isTable) {
    const { rowCid, colCid } = attributes
    if (rowCid && colCid) {
      finalAttributes.rowCid = rowCid
      finalAttributes.colCid = colCid
    }
  }

  return finalAttributes
}

export default buildPost
